// extracted by mini-css-extract-plugin
module.exports = {"about":"about_about__ufnLJ","valueArea":"about_valueArea__cAvV4","ourStoryArea":"about_ourStoryArea__fO1LK"};